import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, ComputedRef } from 'vue'

interface Props {
    // either a number (pixel width/height) or 'tiny', 'small',
    // 'medium', 'large', 'huge', 'massive' for common sizes
    size?: string | number
    lineSize?: number
    lineBgColor?: string
    lineFgColor?: string
    speed?: number
    spacing?: number
    message?: string
    fontSize?: number
    textFgColor?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleSpinner',
  props: {
    size: { default: 32 },
    lineSize: { default: 3 },
    lineBgColor: { default: '#eee' },
    lineFgColor: { default: '#2196f3' },
    speed: { default: 0.8 },
    spacing: { default: 4 },
    message: { default: '' },
    fontSize: { default: 13 },
    textFgColor: { default: '#555' }
  },
  setup(__props: any) {

// Replacement for 'vue-simple-spinner' NPM package component
// https://github.com/dzwillia/vue-simple-spinner/blob/master/src/components/Spinner.vue

const props = __props

const isNumber = function (n) {
    return !isNaN(parseFloat(n)) && isFinite(n)
}

const sizePx: ComputedRef<number> = computed(() => {
    switch (props.size) {
        case 'tiny':
            return 12
        case 'small':
            return 16
        case 'medium':
            return 32
        case 'large':
            return 48
        case 'big':
            return 64
        case 'huge':
            return 96
        case 'massive':
            return 128
    }

    return isNumber(props.size) ? Number(props.size) : 32
})

const lineSizePx: ComputedRef<number> = computed(() => {
    switch (props.size) {
        case 'tiny':
            return 1
        case 'small':
            return 2
        case 'medium':
            return 3
        case 'large':
            return 3
        case 'big':
            return 4
        case 'huge':
            return 4
        case 'massive':
            return 5
    }

    return isNumber(props.lineSize) ? props.lineSize : 4
})

const textMarginTop: ComputedRef<number> = computed(() => {
    switch (props.size) {
        case 'tiny':
        case 'small':
        case 'medium':
        case 'large':
        case 'big':
        case 'huge':
        case 'massive':
            return Math.min(Math.max(Math.ceil(sizePx.value / 8), 3), 12)
    }

    return isNumber(props.spacing) ? props.spacing : 4
})

const textFontSize = computed(() => {
    switch (props.size) {
        case 'tiny':
        case 'small':
        case 'medium':
        case 'large':
        case 'big':
        case 'huge':
        case 'massive':
            return Math.min(Math.max(Math.ceil(sizePx.value * 0.4), 11), 32)
    }

    return isNumber(props.fontSize) ? props.fontSize : 13
})

const spinnerStyle = computed(() => {
    return {
        margin: '0 auto',
        'border-radius': '100%',
        border: lineSizePx.value + 'px solid ' + props.lineBgColor,
        'border-top': lineSizePx.value + 'px solid ' + props.lineFgColor,
        width: sizePx.value + 'px',
        height: sizePx.value + 'px',
        animation:
            'vue-simple-spinner-spin ' + props.speed + 's linear infinite',
    }
})
const text_style = computed(() => {
    return {
        'margin-top': textMarginTop.value + 'px',
        color: props.textFgColor,
        'font-size': textFontSize.value + 'px',
        'text-align': 'center',
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "vue-simple-spinner",
      style: _normalizeStyle(spinnerStyle.value)
    }, null, 4),
    (_ctx.message.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "vue-simple-spinner-text",
          style: _normalizeStyle(text_style.value)
        }, _toDisplayString(_ctx.message), 5))
      : _createCommentVNode("", true)
  ]))
}
}

})